<template>
  <div>
    <nav class="sidebar">
      <div class="sidebar-header">
        <a href="#" class="sidebar-brand">
          <img
            src="/assets/images/logoLtl.png"
            style="width: auto !important"
            alt="LINC MIDDLEWARE"
            :width="40"
            :height="40"
          /><span> LTL </span></a
        >

        <div class="sidebar-toggler not-active">
          <span></span><span></span><span></span>
        </div>
      </div>

      <div class="sidebar-body">
        <ul class="nav" style="text-align: left">
          <li class="nav-item nav-category">{{ $t("MainTxt") }}</li>

          <li class="nav-item">
            <a href="/dashboard" class="nav-link">
              <i class="link-icon" data-feather="box"></i>
              <span class="link-title">{{ $t("dashboardMenu") }}</span>
            </a>
          </li>
          <li
            class="nav-item"
            v-if="this.userPermission?.PlbInboundController?.method_read"
          >
            <a href="/inbound-detail" class="nav-link">
              <i class="link-icon mdi mdi-truck-check"></i>
              <span class="link-title">Inbound Detail</span>
            </a>
          </li>
          <li
            class="nav-item"
            v-if="this.userPermission?.PlbOutboundController?.method_read"
          >
            <a href="/outbound-detail" class="nav-link">
              <i class="link-icon mdi mdi-clipboard-check"></i>
              <span class="link-title">Outbound Detail</span>
            </a>
          </li>
          <li
            class="nav-item"
            v-if="this.userPermission?.PlbMutasiController?.method_read"
          >
            <a href="/mutasi-item" class="nav-link">
              <i class="link-icon mdi mdi-archive"></i>
              <span class="link-title">Mutasi Item</span>
            </a>
          </li>

          <li
            class="nav-item"
            v-if="this.userPermission?.PlbInboundController?.method_read"
          >
            <a href="/summary-inbound" class="nav-link">
              <i class="link-icon mdi mdi-truck-delivery"></i>
              <span class="link-title">Summary Inbound</span>
            </a>
          </li>
          <li
            class="nav-item"
            v-if="this.userPermission?.PlbOutboundController?.method_read"
          >
            <a href="/summary-outbound" class="nav-link">
              <i class="link-icon mdi mdi-clipboard-arrow-right"></i>
              <span class="link-title">Summary Outbound</span>
            </a>
          </li>

          <li
            class="nav-item"
            v-if="this.userPermission?.PlbMutasiController?.method_read"
          >
            <a href="/summary-mutasi" class="nav-link">
              <i class="link-icon mdi mdi-archive-check"></i>
              <span class="link-title">Summary Mutasi</span>
            </a>
          </li>
          <li
            class="nav-item"
            v-if="
              this.userPermission?.PlbLogActivityViewController?.method_read
            "
          >
            <a href="/log-activity" class="nav-link">
              <i class="link-icon mdi mdi-cogs"></i>
              <span class="link-title">Log Activity</span>
            </a>
          </li>
          <li
            class="nav-item"
            v-if="
              this.userPermission?.PlbInventoryDetailViewController?.method_read
            "
          >
            <a href="/inventory-detail" class="nav-link">
              <i class="link-icon mdi mdi-warehouse"></i>
              <span class="link-title">Inventory Detail</span>
            </a>
          </li>

          <br />
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "sidebarMenu",
  props: {
    classMenu: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      locale: "",
      name: "",
      email: "",
      role: "",
      permision_role: [],
      branchDatas: [],
      user_type: "",
      userPermission: null,
    };
  },
  watch: {},
  methods: {
    fetchIt() {
      const userDatas = this.$getUserInfo();
      let arr = {};

      this.name = userDatas.name;
      this.email = userDatas.email;
      this.role = userDatas.role.name;
      this.user_type = userDatas.type;
      userDatas.permision_role.forEach(function (list) {
        const objKey = list.permission.controller;
        arr[objKey] = list;
      });
      this.userPermission = arr;
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
  },
};
</script>
<style scoped></style>
